const ACTIONS = {
    SET_TOKEN_RESETSENHA: 'SET_TOKEN_RESETSENHA'
}

const INITIAL_STATE = {
    token: ''
}

export function ResetarSenhaReducer(state = INITIAL_STATE, action){
    switch (action.type){
        case ACTIONS.SET_TOKEN_RESETSENHA:
            return{
                ...state,
                token: action.token
            }
        default:
            return state;
    }
}